module.exports = __webpack_public_path__ + "media/images/jlp-trust-safety-shield-f21306953d29a8582a78c7863a20cdef.svg";